// Roaster WhatsApp Notification Service using CallMeBot via Cloud Functions
import { auth } from './firebase';

const CLOUD_FUNCTION_URL = 'https://us-central1-greycoffee-f7f71.cloudfunctions.net/sendRoasterNotification';

export const sendRoasterNotification = async (beansRequest) => {
  try {
    // Get the current user's ID token from Firebase Auth
    const idToken = await auth.currentUser.getIdToken();
    
    // Make the API call to Cloud Function
    const response = await fetch(CLOUD_FUNCTION_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${idToken}`,
      },
      body: JSON.stringify({
        beansRequest: beansRequest
      })
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || 'Failed to send roaster notification');
    }

    const data = await response.json();
    console.log('Roaster WhatsApp notification sent successfully:', data);
    return data;
    
  } catch (error) {
    console.error('Error sending roaster WhatsApp notification:', error);
    throw error;
  }
};

export const testRoasterNotification = async () => {
  try {
    // Get authentication token if user is logged in
    const idToken = auth.currentUser ? await auth.currentUser.getIdToken() : null;
    
    if (!idToken) {
      throw new Error('User must be authenticated to send test notification');
    }
    
    // Create a test beans request
    const testBeansRequest = {
      beanName: 'Test Bean (Ethiopian Yirgacheffe)',
      requestedByName: 'Test User',
      requestedByRole: 'Tester',
      requestedQuantity: 1,
      unit: 'kg',
      unitSize: 250,
      notes: 'This is a test notification from the roaster system',
      isCustomRequest: false,
      beanId: 'test-bean-id',
      availableQuantity: 5
    };

    const response = await fetch(CLOUD_FUNCTION_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${idToken}`,
      },
      body: JSON.stringify({
        beansRequest: testBeansRequest
      })
    });
    
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || 'Failed to send test roaster notification');
    }

    const data = await response.json();
    console.log('Test roaster WhatsApp notification sent successfully:', data);
    return data;
    
  } catch (error) {
    console.error('Error sending test roaster notification:', error);
    throw error;
  }
};

// Configuration helper - you can use this to update the credentials
export const updateRoasterNotificationConfig = (apiKey, phoneNumber) => {
  // In a real app, you'd want to store these securely in environment variables
  // or a secure configuration service
  console.warn('UpdateRoasterNotificationConfig called - implement secure storage');
  return {
    apiKey,
    phoneNumber
  };
};